import { SVGProps } from 'react'

export const ServiceIcon4 = (props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) => {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M2 14V5H16C19.3137 5 22 7.68629 22 11V18H6C3.79086 18 2 16.2091 2 14Z"
				fill="url(#paint0_linear_13382_131582)"
			/>
			<path d="M12.834 18L16.5007 5H18.0007C20.2098 5 22.0007 6.79086 22.0007 9V18H12.834Z" fill="#4A4A4A" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.90926 7C5.65264 7 5.44461 7.20803 5.44461 7.46465V8.55447H4.2628C4.01734 8.55447 3.81836 8.75345 3.81836 8.99891C3.81836 9.24437 4.01734 9.44336 4.2628 9.44336H5.44461V10.5353C5.44461 10.792 5.65264 11 5.90926 11C6.16588 11 6.37391 10.792 6.37391 10.5353V9.44336H7.55578C7.80124 9.44336 8.00023 9.24437 8.00023 8.99891C8.00023 8.75345 7.80124 8.55447 7.55578 8.55447H6.37391V7.46465C6.37391 7.20803 6.16588 7 5.90926 7Z"
				fill="white"
			/>
			<defs>
				<linearGradient id="paint0_linear_13382_131582" x1="23.5" y1="18" x2="2" y2="18" gradientUnits="userSpaceOnUse">
					<stop stopColor="#E4EDFC" />
					<stop offset="1" stopColor="#568DFE" />
				</linearGradient>
			</defs>
		</svg>
	)
}
